import React from 'react';
import { Redirect } from 'react-router-dom';
import useRedirectAfterLogin from 'src/hooks/useRedirectAfterLogin';
import ConfigLoader from 'src/components/app/ConfigLoader';
import { useAuth } from 'react-oidc-context';
function Callback() {
    const { isLoading, user } = useAuth();
    const { getRedirectPath } = useRedirectAfterLogin();
    if (user && !isLoading) {
        const path = getRedirectPath();
        return (React.createElement(Redirect, { to: path }));
    }
    return React.createElement(ConfigLoader, null);
}
export default Callback;
